import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import TenantPage from 'components/common/TenantPage';
import { maintenanceService } from 'services/api';
import { EnhancedDataGrid } from 'components/common/enhanced/data-grid';
import { GridColDef } from '@mui/x-data-grid-premium';
import { MaintenanceColumns } from 'components/common/enhanced/common-headers';
import CloseMaintenanceDialog from './CloseMaintenanceDialog';
import { IMaintenance } from 'interfaces';

export const WithoutDateMaintenances = () => {
  const translationPrefix = 'pages.maintenance-expiring';

  const { t } = useTranslation();
  const datagridRefresh = useRef(null);

  const [open, setOpen] = useState(false);
  const [maintenanceToClose, setMaintenanceToClose] = useState<IMaintenance | null>(null);

  const setOpenDialog = (row: IMaintenance) => {
    setOpen(true);
    setMaintenanceToClose(row);
  };

  const setCloseDialog = () => {
    setOpen(false);
    setMaintenanceToClose(null);
  };

  const columns: GridColDef[] = MaintenanceColumns(setOpenDialog, false, false, true);

  return (
    <>
      <TenantPage
        title={t(`${translationPrefix}.title-without-date`)}
        subtitle={t(`${translationPrefix}.subtitle-without-date`)}>
        <EnhancedDataGrid
          columns={columns}
          service={maintenanceService}
          getMethod={maintenanceService.getWithoutDateMaintenances}
          refresh={datagridRefresh}
        />
        <CloseMaintenanceDialog
          closeDialog={setCloseDialog}
          datagridRefresh={datagridRefresh}
          id={maintenanceToClose?.id}
          maintenance={maintenanceToClose}
          open={open}
        />
      </TenantPage>
    </>
  );
};

export default WithoutDateMaintenances;
